import { type ICellEditorParams } from "ag-grid-community";
import { type FC } from "react";

import BooleanInput from "../../../redux-form/BooleanField.js";
import { TableCell } from "../core/TableCell.js";

export const BooleanCellEditor: FC<ICellEditorParams> = (params) => {
  const { value } = params;

  if (params.cellStartedEdit) {
    params.stopEditing(true);
  }

  return (
    <TableCell style={{ textAlign: "center" }}>
      <BooleanInput
        value={value}
        onChange={(value: boolean) => params.node.setDataValue(params.colDef.colId, value)} //.api.chan.startEditingCell({ rowIndex: params.rowIndex, k})}
      />
    </TableCell>
  );
};
